import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import { QUESTION_CONFIG_KEY } from '../../../../constants/questionConfigKeys';
import { NPS_BUTTON_STYLE } from '../../../../constants/displayStyles';
import type { NpsQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';
import { extractHintLabels } from '../labels/extractHintLabels';
import { buildNpsScalePoints } from './buildNpsScalePoints';
import { getConfigValue, hasReverseScaleOrder } from '../shared/configUtils';

export function mapNpsQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell,
  configs: { key: string; value?: string[] }[],
  language?: string
): NpsQuestion {
  const hintLabels = extractHintLabels(raw.answerDetails, language);
  let { minLabel, maxLabel } = hintLabels;
  const { midLabel } = hintLabels;
  let options = buildNpsScalePoints(raw, language);

  const reverseScaleOrder = hasReverseScaleOrder(configs, raw);
  if (reverseScaleOrder) {
    options = [...options].reverse();
    if (minLabel !== undefined && maxLabel !== undefined) {
      [minLabel, maxLabel] = [maxLabel, minLabel];
    }
  }

  let midLabelIndex: number | undefined;
  if (midLabel) {
    midLabelIndex =
      options.length === 11
        ? reverseScaleOrder
          ? 2.5
          : 7.5
        : (options.length - 1) / 2;
  }

  let buttonStyle: NpsQuestion['buttonStyle'] = NPS_BUTTON_STYLE.NUMBERED;
  const variant = getConfigValue(configs, QUESTION_CONFIG_KEY.NPS_BUTTON_VARIANT)?.toLowerCase();
  if (variant === NPS_BUTTON_STYLE.EMOJI) buttonStyle = NPS_BUTTON_STYLE.EMOJI;
  else if (variant === NPS_BUTTON_STYLE.RADIO) buttonStyle = NPS_BUTTON_STYLE.STANDARD;

  const showScaleNumbersRaw = getConfigValue(configs, QUESTION_CONFIG_KEY.SHOW_SCALE_NUMBERS);
  const showScaleNumbers = showScaleNumbersRaw?.toLowerCase() !== 'false';

  return {
    ...shell,
    type: QUESTION_TYPE.NPS_SCALE,
    options,
    ...(minLabel ? { minLabel } : {}),
    ...(midLabel ? { midLabel } : {}),
    ...(midLabelIndex !== undefined ? { midLabelIndex } : {}),
    ...(maxLabel ? { maxLabel } : {}),
    reverseScaleOrder: !!reverseScaleOrder,
    buttonStyle,
    showScaleNumbers,
  };
}
